<template lang="pug">
  // E-mail変更完了
  #change-mail-form-done
    b-container(fluid="fluid")
      .mail-box.mx-auto.justify-content-center.text-center
      .capiton-box.mx-auto
        // カード内の文言表示
        p.mt-3.white-space {{text_content}}
        p.mt-2.white-space.text_caution {{text_caution}}
        router-link.mb-3.d-inline-flex(:to="{name: 'Login'}") ログイン画面へ
</template>

<script>
export default {
  name: "ChangeMailFormDone",
  props: {
    mail_address: { type: String, required: false }
  },
  data() {
    return {
      e_mail: this.mail_address,
      text_content: "E-mail変更が完了しました。\n"
          + "下記リンクからログインしてください。\n",
      text_caution: "※ログイン時に使用するメールアドレスは変更されておりません。\n"
    }
  },
}
</script>

<style scoped>
.mail-box {
  max-width: 600px;
}
.white-space {
  white-space: pre-wrap;
}
.text_caution {
  font-size: 16px;
  color: red !important;
}
</style>